import { jsx as _jsx } from "react/jsx-runtime";
import { Status } from "@chessalpha/core";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
const statuses = [
    Status.MATE,
    Status.RESIGN,
    Status.TIMEOUT,
    Status.OUTOFTIME,
    Status.DRAW,
    Status.STALEMATE,
    Status.MOVE50,
    Status.THREEFOLD,
    Status.INSUFFICIENTMATERIAL,
];
export const StatusExplanation = ({ status }) => {
    const { t } = useTranslation("StatusExplanation");
    return statuses.includes(status) ? (_jsx(Box, { sx: { fontSize: "0.6em", fontWeight: 400 }, children: t(`${status}`) })) : null;
};
//# sourceMappingURL=StatusExplanation.js.map